const changeLocation = data => dispatch => {
    dispatch({
        type: 'LOCATION_CHANGE',
        data
    });
    return Promise.resolve();
};

const setFilters = data => dispatch => {
    dispatch({
        type: 'FILTERS_SET',
        data
    });
    return Promise.resolve();
};
/**
 * Dispatches action for a string key
 * @param {string} key
 * @param {string} actionType
 */
const setTrackingKey = (key, actionType) => data => (dispatch, getState) => {
    const state = getState();

    if (state.track[key] !== data) {
        dispatch({
            type: actionType,
            data
        });
    }

    return Promise.resolve();
};

const setOrigin = setTrackingKey('origin', 'ORIGIN_SET');
const setBrowsingMode = setTrackingKey('browsingMode', 'BROWSING_MODE_SET');
const setCurrBundleResultsetType = setTrackingKey('currBundleResultsetType', 'CURR_BUNDLE_RESULTSET_SET');
const setFromBundleResultsetType = setTrackingKey('fromBundleResultsetType', 'FROM_BUNDLE_RESULTSET_SET');
const setSelectFrom = setTrackingKey('selectFrom', 'SELECT_FROM_SET');
const setFilterInteraction = setTrackingKey('filterInteraction', 'FILTER_INTERACTION_SET');
const setFlowStep = setTrackingKey('flowType', 'FLOW_STEP_SET');

const setOriginSync = data => {
    return {
        type: 'ORIGIN_SET',
        data
    };
};

const setLandingURLSync = data => {
    return {
        type: 'LANDING_URL_SEARCH_SET',
        data
    };
};

const setAutosCurrentPageName = data => {
    return {
        type: 'SET_AUTOS_PAGE_NAME',
        data
    };
};

const setBrowsingModeSync = data => {
    return {
        type: 'BROWSING_MODE_SET',
        data
    };
};

const resetFilters = () => dispatch => {
    dispatch({
        type: 'FILTERS_RESET'
    });
    return Promise.resolve();
};

export {
    changeLocation,
    resetFilters,
    setFilters,
    setOrigin,
    setBrowsingMode,
    setCurrBundleResultsetType,
    setFromBundleResultsetType,
    setSelectFrom,
    setFilterInteraction,
    setOriginSync,
    setBrowsingModeSync,
    setLandingURLSync,
    setAutosCurrentPageName,
    setFlowStep
};
